import React, { useEffect } from "react";

import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";

import { useScrollLock } from "../../hooks/useScrollLock";
import { RootState } from "../../store";
import { AppDispatch } from "../../store";
import { getDays } from "../../store/slices/daysSlice";
import { Products } from "../../types/types"

import { BookingStepDate } from "./BookingStepDate";
import { BookingStepsIndicator } from "./BookingStepsIndicator";
import { BookingStepSuccess } from "./BookingStepSuccess";
import { BookingStepTime } from "./BookingStepTime";
import { BookingStepUser } from "./BookingStepUser";
import {
  Close,
  CloseContainer,
  Overlay,
  PopupWrapper,
  StepWrapper
} from "./styles";
import { useBooking } from "./useBooking";

type BookingPopupProps = {
  visible: boolean;
  onClose: () => void;
  product: Products | null;
}

export const BookingPopup: React.FC<BookingPopupProps> = ({ visible, onClose, product }) => {
  const {
    step,
    selectedDate,
    selectedSlot,
    userData,
    goToNextStep,
    goToPrevStep,
    setSelectedDate,
    setSelectedSlot,
    setUserData
  } = useBooking();

  const dispatch = useDispatch<AppDispatch>();
  const { resetBooking } = useBooking()
  const disabledDays = useSelector((state: RootState) => state.days.dates);

  useEffect(() => {
    if (visible) {
      dispatch(getDays());
    }
  }, [visible, dispatch]);

  useScrollLock(visible)
  if (!visible) return null;

  const renderStep = () => {
    switch (step) {
    case 1:
      return (
        <BookingStepDate
          date={selectedDate}
          onSelectDate={setSelectedDate}
          onNext={goToNextStep}

          disabledDays={disabledDays.map((d) => new Date(d))}
        />
      );
    case 2:
      return (
        <BookingStepTime
          date={selectedDate}
          selectedSlot={selectedSlot}
          onSelectSlot={setSelectedSlot}
          onNext={goToNextStep}
          onBack={goToPrevStep}
        />
      );
    case 3:
      return (
        <BookingStepUser
          userData={userData}
          onChange={setUserData}
          onSubmit={goToNextStep}
          onBack={goToPrevStep}
          selectedDate={selectedDate}
          selectedSlot={selectedSlot}
          product={product}
        />
      );
    case 4:
      return (
        <BookingStepSuccess
          selectedSlot={selectedSlot as string}
          selectedDate={selectedDate as Date}
        />
      );
    default:
      return null;
    }
  };

  return ReactDOM.createPortal(
    <Overlay>
      <PopupWrapper>
        <CloseContainer>
          <Close
            onClick={() => {
              resetBooking();
              onClose();
            }}
          />
        </CloseContainer>
        <StepWrapper>
          <BookingStepsIndicator currentStep={step} />
          {renderStep()}
        </StepWrapper>
      </PopupWrapper>
    </Overlay>,
        document.getElementById("overlay-root") as HTMLElement
  );
};
